/** @jsxImportSource @emotion/react */

import type { ElementType } from "react";
import { Clay } from "../..";
import { cardSectionCSS } from "./CardSection.css";
import type { CardSectionProps } from "./CardSection.types";

export const CardSection = <Element extends ElementType>({
  sx,
  className,
  children,
  as,
}: CardSectionProps<Element>) => {
  return (
    <Clay
      as={as || "section"}
      className={className}
      css={[cardSectionCSS, sx]}
      native={{
        "data-clay-card-section": true,
      }}
    >
      {children}
    </Clay>
  );
};
